import { Button, Input, ModalV2 } from '@components'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type Props = {
  isOpen: boolean
  initialTitle?: string
  placeholder: string
  onClose: () => void
  onApply: (title: string) => void
}

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0 8px;
`

export const ColumnTitleDialog: React.FC<Props> = ({
  isOpen,
  initialTitle,
  placeholder,
  onClose,
  onApply
}) => {
  const [t] = useTranslation()
  const [title, setTitle] = useState(initialTitle || '')

  useEffect(() => {
    if (!isOpen) return
    setTitle(initialTitle || '')
  }, [isOpen, initialTitle])

  return (
    <ModalV2
      isVisible={isOpen}
      handleOnClose={onClose}
      header={t('reports.interactive.column.renameTitle')}
      width={420}
      autoHeight
      footer={
        <>
          <Button type="button" onClick={onClose}>
            {t('general.cancel')}
          </Button>
          <Button type="button" intent="primary" onClick={() => onApply(title.trim())}>
            {t('reports.interactive.periodDialog.apply')}
          </Button>
        </>
      }
    >
      <Fields>
        <Input
          id="interactive-column-title"
          label={t('reports.interactive.column.renameLabel')}
          placeholder={placeholder}
          value={title}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setTitle(event.currentTarget.value)
          }
        />
      </Fields>
    </ModalV2>
  )
}
